export default [
  {
    label: '基本教學',
    value: 'tutorial',
  },
  {
    label: '新功能介紹',
    value: 'new',
  },
  {
    label: '疑難排解',
    value: 'qa',
  },
  {
    label: '功能更新',
    value: 'update',
  },
  {
    label: '檔案下載',
    value: 'download',
  },
];
